import React, { useMemo, useState } from "react";
import {
  ActionButton,
  ComboBox,
  IComboBox,
  IComboBoxOption,
  Stack,
  SearchBox,
} from "@fluentui/react";
import { styles } from "./filterComponent.styles";
import { FilterAction } from "./FilterComponent";

interface ComboBoxFilterProps {
  filterKey: string;
  text: string;
  options: IComboBoxOption[];
  onChange: (
    event?: React.FormEvent<IComboBox>,
    option?: IComboBoxOption,
    index?: number,
    value?: string,
  ) => void;
  clearable?: boolean;
  searchable?: boolean;
  [key: string]: any;
}
const ComboBoxFilter: React.FC<ComboBoxFilterProps> = ({
  filterKey,
  text,
  clearable,
  options,
  onChange,
  searchable,

  ...props
}) => {
  const [searchText, setSearchText] = useState("");

  const filteredOptions = useMemo(
    () =>
      searchText
        ? options.filter((o) =>
            o.text.toLowerCase().includes(searchText.toLowerCase()),
          )
        : options,
    [options, searchText],
  );

  return (
    <ComboBox
      className={styles.comboBox}
      key={filterKey}
      placeholder={`Filter by ${text}`}
      useComboBoxAsMenuWidth={true}
      multiSelect={true}
      {...props}
      onChange={(event, option, index, value) => {
        setSearchText("");
        onChange(event, option, index, value);
      }}
      options={filteredOptions}
      autoComplete="off"
      allowFreeform={false}
      calloutProps={{
        style: {
          maxHeight: 400,
        },
      }}
      onRenderUpperContent={() => {
        if (searchable) {
          return (
            <SearchBox
              placeholder={`Search ${text.toLowerCase()}...`}
              className={styles.comboBoxSearchBox}
              value={searchText}
              onChange={(_, newValue) => setSearchText(newValue || "")}
              onClear={() => setSearchText("")}
              onMouseDown={(e) => e.stopPropagation()}
              onClick={(e) => e.stopPropagation()}
              styles={{
                root: {
                  margin: 4,
                },
              }}
            />
          );
        }
        return null;
      }}
      onRenderLowerContent={() => {
        if (clearable) {
          return (
            <Stack horizontal horizontalAlign="end">
              <ActionButton
                onClick={() =>
                  onChange(undefined, {
                    key: FilterAction.Clear,
                    text: FilterAction.Clear,
                  })
                }
                iconProps={{ iconName: "Clear", style: { fontSize: 10 } }}
              >
                Clear
              </ActionButton>
            </Stack>
          );
        }
        return null;
      }}
    />
  );
};

export default ComboBoxFilter;
